$(function(){
	var selectEls = $('.form__select select');

	// initialize selectize
	selectEls.selectize({
		openOnFocus: true,

    onInitialize: function () {
			let that = this;
			
			// ignore focus reopen
			that.$control.on("click", function () {
				that.ignoreFocusOpen = true;
				setTimeout(function () {
					that.ignoreFocusOpen = false;
				}, 50);
			});

			// set selects as loaded
			$('.form__select').addClass('active');
    },

    onFocus: function () {
        if (!this.ignoreFocusOpen) {
            this.open();
        }
		},

		render: {
			option: function(item, escape){
				return `<div class="option selected active"` 
				+ `${!item.disabled ? 'data-selected=""' : ''}` 
				+ `data-value="${item.value}">${item.text}</div>`;
			}
		}
	});
});